// Country IDs in ISO 3166-1 alpha-3 standard
export enum LANGUAGES {
  PER = 'es-PE',
  MYS = 'en-MY',
  CHL = 'es-CL',
  BRA = 'pt-BR',
  COL = 'es-CO'
}
